import React from 'react';
import './HistoricAmount.scss';
import useIGTranslation from 'hooks/useIGTranslation';
import { getAmountFromSiteId } from './historicAmountFunctions';

const HistoricAmount = () => {
  const { t } = useIGTranslation();
  return (
    <div className="historic-amount">
      <div className="historic-amount__logo">
        <div className="historic-amount__logo__text-container">
          <div className="historic-amount__logo__text-container__top-text">{t('this-season-we-paid-out-over')}</div>
          <div className="historic-amount__logo__text-container__middle-text">{getAmountFromSiteId(t)}</div>
          <div className="historic-amount__logo__text-container__bottom-text">{t('in-cash')}</div>
        </div>
        <div className="historic-amount__logo__date">{t('historic-date')}</div>
      </div>
    </div>
  );
};

export default HistoricAmount;
